enum Permission {
  CreateOrganisationUnit = 'CreateOrganisationUnit',
  ReadOrganisationUnit = 'ReadOrganisationUnit',
  UpdateOrganisationUnit = 'UpdateOrganisationUnit',
  DeleteOrganisationUnit = 'DeleteOrganisationUnit',

  CreateRole = 'CreateRole',
  ReadRole = 'ReadRole',
  UpdateRole = 'UpdateRole',
  DeleteRole = 'DeleteRole',

  ReadSystems = 'ReadSystems',
  CreateSystems = 'CreateSystems',
  UpdateSystems = 'UpdateSystems',
  DeleteSystems = 'DeleteSystems',
  ReadGateways = 'ReadGateways',
  CreateGateways = 'CreateGateways',
  UpdateGateways = 'UpdateGateways',
  DeleteGateways = 'DeleteGateways',
  ReadConnectors = 'ReadConnectors',
  CreateConnectors = 'CreateConnectors',
  UpdateConnectors = 'UpdateConnectors',
  DeleteConnectors = 'DeleteConnectors',

  CreateDevice = 'CreateDevice',
  ReadDevice = 'ReadDevice',
  UpdateDevice = 'UpdateDevice',
  DeleteDevice = 'DeleteDevice',
  LinkDevice = 'LinkDevice',

  AppAccess = 'AppAccess',
  ReadOverview = 'ReadOverview',

  LinkScenario = 'LinkScenario',

  ReadResidentsSettings = 'ReadResidentsSettings',
  UpdateResidentsSettings = 'UpdateResidentsSettings',
  ReadResidentsChangeLog = 'ReadResidentsChangeLog',
  UpdateResidentAbsence = 'UpdateResidentAbsence',

  ReadHistory = 'ReadHistory',
  ReadHistoryDetails = 'ReadHistoryDetails',

  ReadTenant = 'ReadTenant',
  UpdateTenant = 'UpdateTenant',

  MuteApp = 'MuteApp',
  UserPreferences = 'UserPreferences',

  ManageTemporaryAccess = 'ManageTemporaryAccess',
  RequestTemporaryChannelAccess = 'RequestTemporaryChannelAccess',

  ReadFaults = 'ReadFaults',
  ReadFaultsOnUnlinkedDevices = 'ReadFaultsOnUnlinkedDevices',

  SettingsEmergencyAlarm = 'SettingsEmergencyAlarm',
  SettingsMalfunctionNotifications = 'SettingsMalfunctionNotifications',
  SettingsExplanationLink = 'SettingsExplanationLink',
  SettingsWanderingBoundaries = 'SettingsWanderingBoundaries',
  SendTestEvent = 'SendTestEvent',

  CentralSupportPortalAccess = 'CentralSupportPortalAccess',
  CentralSupportReadFaults = 'CentralSupportReadFaults',

  InsightsPortalAccess = 'InsightsPortalAccess',
  ReadAlertsHistory = 'ReadAlertsHistory',

  CareConnectReadAndUpdateSettings = 'CareConnectReadAndUpdateSettings',
}

export default Permission;
